import { isAxiosError } from 'axios';

export type CounterInUseErrorBody = {
  code: 'COUNTER_IN_USE';
  counterId: string;
  activeBookingId: string;
  message?: string;
};

export function isCounterInUseError(
  error: unknown,
): error is { response: { data: CounterInUseErrorBody } } {
  return (
    isAxiosError(error) &&
    error.response?.status === 409 &&
    (error.response.data as CounterInUseErrorBody | undefined)?.code === 'COUNTER_IN_USE'
  );
}

export function getCounterInUseDetails(error: unknown): CounterInUseErrorBody | null {
  if (!isCounterInUseError(error)) return null;
  return error.response.data;
}
